<span class="{{ status.type_value | className }}">
  {{ status.type_label }}
</span>
